import { Flex, Box, Spacer, Stack, Checkbox } from '@chakra-ui/react'
import { FC } from 'react'

import useFollowUpReabAlert from '@hook/alerts/use-followup-reab'

import ModalComment from './ModalCommentReab'

const BarToggle: FC = () => {
  const { selecteds, handleCheck } = useFollowUpReabAlert()

  return (
    <Flex
      height="58px"
      paddingX={4}
      borderBottom="solid 1px"
      borderColor="gray.200"
      alignItems="center"
    >
      <Box>{selecteds.length > 0 ? <ModalComment /> : <></>}</Box>

      <Spacer />

      <Box>
        <Stack spacing={[1, 5]} direction={['column', 'row']}>
          <Checkbox
            size="md"
            borderColor="black"
            onChange={e => {
              handleCheck(e.target.checked, 2)
            }}
            colorScheme="orange"
            defaultIsChecked
          >
            Atenção
          </Checkbox>
          <Checkbox
            size="md"
            borderColor="black"
            colorScheme="green"
            onChange={e => {
              handleCheck(e.target.checked, 1)
            }}
            defaultIsChecked
          >
            No Prazo
          </Checkbox>
          <Checkbox
            size="md"
            borderColor="black"
            colorScheme="red"
            onChange={e => {
              handleCheck(e.target.checked, 3)
            }}
            defaultIsChecked
          >
            Atrasados
          </Checkbox>
        </Stack>
      </Box>
    </Flex>
  )
}

export default BarToggle
